// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB6y6UkEGX4kh8AAOqKwffD0ptggUhtG2M",
  authDomain: "lnp-orderhandling-app.firebaseapp.com",
  projectId: "lnp-orderhandling-app",
  storageBucket: "lnp-orderhandling-app.appspot.com",
  messagingSenderId: "1049704968497",
  appId: "1:1049704968497:web:983024a4a1e71566b70010"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage();
